import type { Invoice } from "~/shared/schemas/invoice-schema.ts";

const INELIGIBLE_STATUSES: ReadonlySet<string> = new Set([
	"paid",
	"payment pending",
	"pending payment",
]);

export const isInvoiceEligibleForPayment = (invoice: Invoice): boolean => {
	const status = invoice.invoiceStatus?.trim().toLowerCase() ?? "";
	return !INELIGIBLE_STATUSES.has(status);
};
